import { z } from 'zod';
export const FileGroupScope = z.object({
    groupId: z.string().uuid(),
    groupSlug: z.string().optional(),
    groupName: z.string().optional(),
    availableAt: z.string().datetime({ offset: true }).nullable(),
    expiresAt: z.string().datetime({ offset: true }).nullable(),
    allowParentAccess: z.boolean().default(false),
    pendingOpen: z.boolean().default(false),
    inheritedFromFolderId: z.string().uuid().nullable().optional(),
});
export const FileAvailabilityState = z.enum(['available', 'scheduled', 'pending', 'expired']);
//# sourceMappingURL=scope.js.map